module.exports = __webpack_public_path__ + "static/media/Kirlia_gaussian2.2c1f6389.png";